'use strict';

define('features/ctas/compare.cta',[
  'jquery',
  'lib/page-cache',
  'lib/util/tda.config',
  './cta.types'
], function (
  $,
  PageCache,
  tdaConfig,
  ctaTypes
) {
  var __type = ctaTypes['compare']; // eslint-disable-line dot-notation
  var __defaultUrl = '/' + tdaConfig.site.context_url + '/compare/';

  return function compareCta(year, series, $scope) {
    var $ctaScope = $scope || $('body');
    var $compareCtas = $("a[data-destination='" + __type + "']", $ctaScope);

    if (!$compareCtas.length) return;

    if (!year || !series) {
      $compareCtas.each(function () {
        $(this).attr('href', __defaultUrl);
      });
      return;
    }

    PageCache.await('series.compare.urlMap').then(function (compareUrls) {
      $compareCtas.each(function () {
        var $this = $(this);
        var key = [year, series].join('-');
        var url = compareUrls[key];
        if (url) {
          $this.attr('href', url);
        } else {
          $this.attr('href', __defaultUrl + '?series=' + series);
        }
      });
    }).catch(function (error) { console.warn('err: ', error); }); // eslint-disable-line no-console
  };
});

